// @greenlight-spec: 10-security-compliance.md#compliance-evidence-not-compliance-bundles

import type { GdprEvidence } from '@greenlight/contract';

import { escapeCsvCell as escape } from './csv.js';

/** The payload verbatim — what a compliance platform ingests. */
export function buildGdprJson(evidence: GdprEvidence): string {
  return `${JSON.stringify(evidence, null, 2)}\n`;
}

const CONTROL_HEADER = [
  'control',
  'chapter',
  'title',
  'coverage',
  'mechanism',
  'greenlight_checks',
] as const;

const INTEGRATION_HEADER = [
  'integration',
  'display_name',
  'region',
  'residency_recorded',
  'grant_blocked',
] as const;

/**
 * Two tables in one file, matching the SOC 2 export's shape: the article mapping, then
 * the integrations and the residency standing behind each.
 */
export function buildGdprCsv(evidence: GdprEvidence): string {
  const lines: string[] = [];
  lines.push(
    escape(`# ${evidence.framework} article coverage — generated ${evidence.generated_at}`),
  );
  lines.push(escape(`# ${evidence.scope_note}`));
  lines.push('');
  lines.push(CONTROL_HEADER.join(','));
  for (const row of evidence.controls) {
    lines.push(
      [row.control, row.chapter, row.title, row.coverage, row.mechanism, row.policy_ids.join(' ')]
        .map(escape)
        .join(','),
    );
  }
  lines.push('');
  lines.push(INTEGRATION_HEADER.join(','));
  for (const row of evidence.integrations) {
    lines.push(
      [
        row.name,
        row.display_name,
        row.region,
        row.residency_recorded ? 'yes' : 'no',
        row.grant_blocked ? 'yes' : 'no',
      ]
        .map(escape)
        .join(','),
    );
  }
  return `${lines.join('\n')}\n`;
}
